import AbstractListView from '@UI/Store/AbstractListView';
import type UserView from '@UI/Store/Users/Views/UserView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Scoped by both `accountId` and `roleId`, not `accountId` alone: `stopOn` must be able to tell one
 * role's preview list apart from another's, and a `UsersListView` from either.
 */
class RoleImpactedUsersListView extends AbstractListView<UserView> {
	readonly accountId: number;
	readonly roleId: number;
	readonly totalRecords: number;

	constructor(list: readonly UserView[], accountId: number, roleId: number, totalRecords: number) {
		super(list, 'RoleImpactedUsersListView');

		this.accountId = accountId;
		this.roleId = roleId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}
}

export default RoleImpactedUsersListView;
